import React, { useState } from "react";
import Contacts from "@/pages/contacts";
import Denmarkstudentvisaimport from "@/pages/denmarkstudentvisaimport";
const Denmarkstudentvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/denmarked.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
         
        </div>
      </div>
      <div className="px-5 md:px-20">
        <div className="mt-10 w-full text-center text-2xl font-bold text-[#011473] drop-shadow-md md:ml-32 md:mt-10 md:w-3/4 md:text-left md:text-3xl">
          Study in Denmark: Your Gateway to Global Opportunities
        </div>
      </div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-8">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/students.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-8 lg:w-1/2">
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="text-black font-bold">Two-Tier System:</a> Undergraduate (Bachelor’s) and postgraduate
              (Master’s/PhD), aligned with European standards.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold">Professional Academies:</a> Short-term pre-Bachelor programs
              (Academy Profession degrees).
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold">University Colleges:</a> 3-4 year Bachelor’s programs with a
              professional focus.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold">Universities:</a> Specialized or multi-disciplinary programs in
              engineering, business and technology.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
            <a className="text-black font-bold">Arts Universities:</a> Programs in visual arts, music, theater and
              media under the Danish Ministry of Culture.
            </span>
          </div>
        </div>
      </div>

      <div className="px-5 md:px-20">
  <h2 className="mb-5 text-left text-xl font-bold text-[#011473] md:ml-32 md:w-2/3 md:text-2xl">
    Revised and Concise Points for Visa World
  </h2>
  <div className="mb-20 space-y-4 text-left text-black md:ml-32">
    {["Application Process: Apply by 15th March for August intake (responses by 28th July) or by 1st September for spring intake.",
      "Postgraduate Programs: Deadlines vary by institution. Contact your chosen university for specific timelines and requirements.",
      "Tuition Fees: €6,000–€16,000 annually for international students; medicine up to €35,000. Permanent residents exempt.",
      "PhD Programs: Fully funded through collaborations, with self-financed programs costing €10,000–€16,000 annually.",
      "Scholarships: Programs like Nordplus and Erasmus fund Bachelor's, Master's and PhD students, especially for studies in Danish.",
      "Why Choose Visa World: Expert guidance, personalized solutions and a trusted global presence for students and migrants.",
      "Why Study in Denmark: Affordable tuition, world-class education and a welcoming, innovative society ranked among the happiest globally."
    ].map((text, index) => (
      <div key={index} className="flex items-start">
        <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <span className="ml-3">
          <span className="font-bold text-black">{text.split(':')[0]}:</span>
          <span className="ml-1 font-medium text-gray-700">{text.split(':').slice(1).join(':')}</span>
        </span>
      </div>
    ))}
  </div>
</div>




      <Denmarkstudentvisaimport />
      <div className="flex w-full flex-col items-center justify-center py-20">
        {isOpen && (
          <div className="mb-6 w-3/4 items-center justify-center text-black rounded-md bg-gray-100 p-4 text-lg shadow-md">
            <p>
              <br />- <strong>Why Study in Denmark?</strong>
              <br />- <strong>World-Class Education System:</strong> Denmark is
              globally recognized for its innovative and high-quality education
              standards.
              <br />- <strong>Thriving Economy:</strong> A robust and dynamic
              economy enhances career opportunities for graduates.
              <br />- <strong>Problem-Solving Curriculum:</strong> Danish
              universities emphasize a practical, problem-based approach to
              education, preparing students for the global job market.
              <br />- <strong>Affordable Education:</strong> Low tuition fees
              and access to top-tier education make Denmark an attractive choice
              for EU and non-EU students alike.
              <br />- <strong>Welcoming Environment:</strong> The Danish people
              are known for their inclusivity, creating a supportive and
              friendly atmosphere for international students.
              <br />- <strong>Beautiful Living Experience:</strong> Denmark
              offers stunning architecture, breathtaking landscapes and a high
              quality of life, making it a delightful place to live and study.
              <br />- <strong>Strong Career Prospects:</strong> Universities in
              Denmark focus on equipping students with skills for excellent job
              placements worldwide.
              <br />
              Apply for your Denmark Student Visa today and embark on a journey
              of educational and personal growth.
              <br />
            </p>
          </div>
        )}
        <button
          onClick={toggleAnswer}
          className="w-2/2 flex items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 md:w-1/2"
        >
          Why Study in Denmark? Learn More
          <svg
            className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 5v14M5 12l7 7 7-7"></path>
          </svg>
        </button>
      </div>

      <Contacts />
    </>
  );
};

export default Denmarkstudentvisa;
